/**
 * Narcis's facets (`@core/wall/facets`): its own use (what the portrait is for or about) and role (the figure
 * it plays), then the shared axes (region stands for culture), each what a visitor chooses by. Pack-level only.
 */
import {COLOUR, ERA, REGION, type HouseFacets} from '@core/wall/facets'

export const NARCIS_FACETS: HouseFacets = [
    {
        key: 'use',
        label: 'Use',
        required: true,
        values: [
            {id: 'headshots', label: 'Headshots', short: 'headshots', meta: 'Work and profile portraits: LinkedIn, corporate, team, bio'},
            {id: 'professions', label: 'Professions & uniforms', short: 'professions', meta: 'A trade, a job, a service uniform, at work'},
            {id: 'dating', label: 'Dating & casual', short: 'dating', meta: 'Dating profiles, everyday outfits, relaxed portraits'},
            {id: 'weddings', label: 'Weddings', short: 'weddings', meta: 'Brides, grooms, ceremonies, bridal parties'},
            {id: 'red-carpet', label: 'Red carpet & gala', short: 'red carpet', meta: 'Premieres, balls, black tie, award nights'},
            {id: 'fashion', label: 'Fashion & designers', short: 'fashion', meta: 'Fashion houses, fashion weeks, tailoring, a styled look'},
            {id: 'icons', label: 'Icons & stars', short: 'icons', meta: "A named celebrity's or star's look"},
            {id: 'history', label: 'History & royalty', short: 'history', meta: 'Kings, queens, courts, soldiers, period dress'},
            {id: 'myth', label: 'Myth & fiction', short: 'myth', meta: 'Gods, heroes, villains, fairy tales, fictional characters'},
            {id: 'heritage', label: 'Cultural dress & festivals', short: 'cultural dress', meta: 'Traditional dress, cultural ceremonies, festivals'},
            {id: 'travel', label: 'Travel & places', short: 'travel', meta: 'Cities, landmarks and destinations as the subject'},
            {id: 'nature', label: 'Nature & seasons', short: 'nature', meta: 'Landscapes, gardens, weather and the time of year'},
            {id: 'sport', label: 'Sport & adventure', short: 'sport', meta: 'Athletes, supporters, stadiums, the outdoors in action'},
            {id: 'nightlife', label: 'Nightlife & music', short: 'nightlife', meta: 'Parties, clubs, concerts, musicians, subcultures'},
            {id: 'art', label: 'Art & painting', short: 'art', meta: "Painterly portraits, a painter's muse, art movements"},
        ],
    },
    {
        key: 'role',
        label: 'Role',
        required: false,
        values: [
            {id: 'professional', label: 'At work', short: 'at work', meta: 'A trade, a job, a uniform, an office or a workshop'},
            {id: 'ruler', label: 'Ruler or noble', short: 'ruler', meta: 'Kings, queens, emperors, nobles, courtiers'},
            {id: 'warrior', label: 'Warrior', short: 'warrior', meta: 'Soldiers, knights, samurai, gladiators, fighters'},
            {id: 'performer', label: 'Performer or star', short: 'performer', meta: 'Actors, singers, musicians, dancers, celebrities'},
            {id: 'mythic', label: 'Mythic or fictional', short: 'mythic', meta: 'Gods, heroes, villains, fairy-tale and film characters'},
            {id: 'athlete', label: 'Athlete', short: 'athlete', meta: 'Players, runners, climbers, supporters'},
            {id: 'artist', label: 'Artist or muse', short: 'artist', meta: 'Painters, poets, models, a muse'},
            {id: 'explorer', label: 'Traveller', short: 'traveller', meta: 'Tourists, explorers, wanderers in a place'},
            {id: 'celebrant', label: 'Celebrant', short: 'celebrant', meta: 'Brides, grooms, guests, festival-goers, honorees'},
        ],
    },
    REGION,
    ERA,
    COLOUR,
]
